import type { ReviewLevel, SubmissionStatus } from './types'

/**
 * The review side's labels. The figures (the funnel, failed checks, tonnes,
 * which level a submission waits at and whether it is overdue) come worked
 * out from the API.
 */

export const STATUS_LABEL: Record<SubmissionStatus, string> = {
  draft: 'Draft',
  submitted: 'Submitted',
  validation_in_progress: 'Validation in progress',
  validated: 'Validated',
  in_final_review: 'In final review',
  approved: 'Approved',
  returned: 'Returned',
}

export const LEVEL_LABEL: Record<ReviewLevel, string> = {
  1: 'First review',
  2: 'Final review',
}

export const LEVEL_ROLE: Record<ReviewLevel, string> = {
  1: 'Buyer',
  2: 'Regional sourcing lead',
}

export function daysSince(iso: string, now = new Date()): number {
  return Math.max(0, Math.floor((now.getTime() - new Date(iso).getTime()) / 86_400_000))
}
